export const GIRDER_DEFAULT_THUMBNAIL_WIDTH = 160;
export const GIRDER_DEFAULT_THUMBNAIL_HEIGHT = 100;

function girderImageParams(options = {}) {
    const width = options.width ?? GIRDER_DEFAULT_THUMBNAIL_WIDTH;
    const height = options.height ?? GIRDER_DEFAULT_THUMBNAIL_HEIGHT;
    const encoding = options.encoding ?? 'JPEG';
    const params = new URLSearchParams({
        encoding,
        width: String(width),
        height: String(height),
    });
    if (options.resample !== undefined) {
        params.set('resample', String(options.resample));
    }
    return params;
}

/**
 * Build a Girder tiles/thumbnail URL using stock default dimensions (160×100).
 * Display size is controlled separately via CSS on the img element.
 */
export function girderThumbnailUrl(api, itemId, options = {}) {
    return api.url(`/item/${itemId}/tiles/thumbnail?${girderImageParams(options).toString()}`);
}

/**
 * Build a Girder associated label image URL using the same stock dimensions as
 * girderThumbnailUrl so list + peek share one browser cache entry.
 */
export function girderLabelImageUrl(api, itemId, options = {}) {
    return api.url(`/item/${itemId}/tiles/images/label?${girderImageParams(options).toString()}`);
}
